// eslint-disable-next-line import/no-extraneous-dependencies
import crypto from "crypto-js";
import { STORAGE_KEYS, getFromStorage, setToStorage } from "../helpers";

export function generateSEKAndHash(token: string | null) {
  const language = getFromStorage(STORAGE_KEYS.language);
  const iv = "5YPcLSBvFcGcamF2".slice(0, 16);
  try {
    const timeStampLocal = getFromStorage(STORAGE_KEYS.timeStamp);
    const timestamp = new Date().toISOString();
    if (!timeStampLocal) {
      setToStorage(STORAGE_KEYS.timeStamp, timestamp);
    }

    const deviceId = navigator.userAgent;

    const key = crypto.lib.WordArray.random(32);
    let dataPayload = {};
    if (token === "" || token === null || token === undefined) {
      dataPayload = {
        date: new Date().toISOString(),
        deviceid: timeStampLocal ? timeStampLocal : timestamp,
        lang: language === "ar" ? "ar" : "en",
      };
    } else {
      dataPayload = {
        authorization: `Bearer ${token}`,
        date: new Date().toISOString(),
        deviceid: timeStampLocal ? timeStampLocal : timestamp,
        lang: language === "ar" ? "ar" : "en",
      };
    }
    let appkey = JSON.stringify(dataPayload);

    const encrypted = crypto.AES.encrypt(appkey, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}

export function generateEncryptedKeyBody(body: any) {
  const iv = "5YPcLSBvFcGcamF2".slice(0, 16);
  try {
    const key = crypto.lib.WordArray.random(32);
    let dataPayload = JSON.stringify(body);

    const encrypted = crypto.AES.encrypt(dataPayload, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}
